<style lang="scss" scoped>
hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #eeeeee;
  margin: 1em 0;
  padding: 0;
}
strong {
  font-size: 120%;
}
.rssi small, .rssi strong {
  line-height: 200%;
}
</style>

<template>

  <v-flex grow>


    <v-expand-x-transition>
      <v-layout row wrap>

        <v-flex shrink>
          <v-icon @click="expand = !expand" class="black--text mt-2">{{ expand ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-flex>

        <v-flex v-show="expand" shrink class="mt-2">
          <h1 class="pa-0 ma-0">RSSI: </h1>
        </v-flex>

        <v-flex v-show="expand" grow class="mt-2">
          <v-layout row nowrap justify-space-around>
            <v-flex v-for="(rssi, mac) in rssis" v-if="rssi.received <= 60" :key="mac" shrink align-content-center>
              <div :class="'rssi ' + getColor(rssi.received)+'--text'">
                <small>{{mac}}:</small> <strong>{{rssi.rssi}}</strong>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>
    </v-expand-x-transition>

    <hr v-show="expand" class="mb-0">
  </v-flex>

</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "rssi",
  props: ['slug'],
  data() {
      return {
        expand: true,
      }
  },
  computed: {
     ...mapGetters(['devices/device']),
    rssis: function (getter) {
      return getter['devices/device'](this.slug).data.rssi;
    }
  },
  methods: {
    getColor(received) {
      switch (true) {
        case received > 40:
          return 'red'
        case received > 20:
          return 'deep-orange'
        case received > 12:
          return 'orange'
        default:
          return 'green'
      }
    }
  }
}
</script>
